import { useState, useEffect } from "react";
import { Environment } from "../../environments/environment";

import "./Expos.css";

interface Exposition {
  cardStyle: string;
  image: string;
  date: string;
  title: string;
  description: string;
  websiteUrl?: string;
  websiteText?: string;
  addressLine1: string;
  addressLine2: string;
}

function Expos() {
  const [expositions, setExpositions] = useState<Exposition[]>([]);
  const baseUrl = Environment.getBaseUrl();
  const dataUrl = `${baseUrl}/config/expositions.json`;

  useEffect(() => {
    const fetchExpositions = async () => {
      try {
        const response = await fetch(dataUrl);
        if (!response.ok) {
          throw new Error(
            `Erreur lors de la récupération des données: ${response.status}`
          );
        }
        const data = await response.json();
        setExpositions(data as Exposition[]);
      } catch (error: any) {
        console.error(
          "Erreur lors du chargement des expositions depuis l'URL:",
          error.message
        );
      }
    };

    fetchExpositions();
  }, [dataUrl]);

  return (
    <main className="container-fluid">
      <p>&nbsp;</p>
      <section className="row justify-content-center text-center">
        {expositions.map((exposition, index) => (
          <div key={index} className="m-1 mb-4 col-10 col-md-6 col-lg-3">
            <div className={`card ${exposition.cardStyle}`}>
              <img
                src={`${Environment.getBaseUrl()}/img_expos/${
                  exposition.image
                }`}
                className="card-img-top"
                alt={exposition.title}
              />
              <div className="card-body">
                <p className="card-text expo-titre1">{exposition.date}</p>
                <h5 className="card-title expo-titre">{exposition.title}</h5>
                <p className="card-text">{exposition.description}</p>
                {exposition.websiteUrl && exposition.websiteText && (
                  <a
                    href={exposition.websiteUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {exposition.websiteText}
                    <i className="fas fa-external-link-alt"></i>
                  </a>
                )}
              </div>
              <div className="card-footer">
                <small className="text-muted">{exposition.addressLine1}</small>
                <br />
                <small className="text-muted">{exposition.addressLine2}</small>
              </div>
            </div>
          </div>
        ))}
      </section>
    </main>
  );
}

export default Expos;
